import { lazy } from 'react';

const resolutionListeners = new Set();
const resolutionVersions = new Map();
let latestResolutionVersion = 0;

const notifyRouteResolution = (requestedHash) => {
    const version = ++latestResolutionVersion;
    resolutionVersions.set(requestedHash, version);
    resolutionListeners.forEach((listener) => listener(requestedHash, version));
};

export const getRouteResolutionVersion = (routeHash) => resolutionVersions.get(routeHash) || 0;

export const subscribeToRouteResolution = (listener) => {
    resolutionListeners.add(listener);
    return () => resolutionListeners.delete(listener);
};

export class RouteChunkLoadError extends Error {
    constructor(error) {
        super(error?.message || 'Failed to load route chunk');
        this.name = 'RouteChunkLoadError';
        this.originalError = error;
    }
}

export const isRouteChunkLoadError = (error) => error instanceof RouteChunkLoadError;

export const lazyRoute = (load) =>
    lazy(() => {
        const requestedHash = window.location.hash;

        return load()
            .then((module) => {
                notifyRouteResolution(requestedHash);
                return module;
            })
            .catch((error) => {
                throw new RouteChunkLoadError(error);
            });
    });
